<div class="layout-auto-1-auto">
	<!-- Search Header -->
	<exg-search-bar (Search)="localConfig.attachmentJagTable.search($event)"
	                [placeholder]="getRessource('SearchHolder')"
	                class="span-layout">
		<ng-template #leftTemplate>
			<div class="selectall">
				<i class="md-btn-circular fa-duotone fa-check-double"
				   [class.c-green]="allSelected"
				   (click)="toggleSelectAll()"
				   [tooltip]="allSelected ? getRessource('ActionMenu.DeselectAll') : getRessource('ActionMenu.SelectAll')">
				</i>
			</div>
		</ng-template>
		<ng-template #rightTemplate>
			<i (click)="downloadSelection()" class="search-action fa-file-zip"
			   flow="left"
			   [class.fa-duotone]="selectedDocsCount > 0"
			   [class.fa-regular]="selectedDocsCount === 0"
			   [class.disabled]="selectedDocsCount === 0"
         [tooltip]="getRessource('tooltip.DownloadAsZip')">
			</i>
			<app-exg-dropdown>
				<ng-template #hostTemplate>
					<i class="search-action fa-copy"
					   flow="left"
					   [class.fa-duotone]="selectedDocsCount > 0"
					   [class.fa-regular]="selectedDocsCount === 0"
					   [class.disabled]="selectedDocsCount === 0"
             [tooltip]="getRessource('tooltip.CopyAs')">
					</i>
				</ng-template>
				<ng-template #contentTemplate let-popup>
					<ng-container *ngIf="selectedDocsCount > 0">
						<div class="md-menu-item"
						     (click)="openCaseModal(true);popup.close();">
							{{getResource("ActionMenu.CopyCase")}}
						</div>
						<div class="md-menu-item"
						     (click)="openTaskModal(true);popup.close();">
							{{getResource("ActionMenu.CopyTask")}}
						</div>
					</ng-container>
				</ng-template>
			</app-exg-dropdown>
			<app-exg-dropdown>
				<ng-template #hostTemplate>
					<i class="search-action fa-link"
					   flow="left"
					   [class.fa-duotone]="selectedDocsCount > 0"
					   [class.fa-regular]="selectedDocsCount === 0"
					   [class.disabled]="selectedDocsCount === 0"
             [tooltip]="getRessource('tooltip.LinkAs')">
					</i>
				</ng-template>
				<ng-template #contentTemplate let-popup>
					<ng-container *ngIf="selectedDocsCount > 0">
						<div class="md-menu-item"
						     (click)="openCaseModal(false, true);popup.close();">
							{{getResource("ActionMenu.LinkCase")}}
						</div>
						<div class="md-menu-item"
						     (click)="openTaskModal(false, true);popup.close();">
							{{getResource("ActionMenu.LinkTask")}}
						</div>
						<div class="md-menu-item"
						     [class.disabled]="selectedLinkDocs() === 0"
						     (click)="unlinkDocuments();popup.close();">
							{{getResource("ActionMenu.Unlink")}}
						</div>
					</ng-container>
				</ng-template>
			</app-exg-dropdown>
			<i (click)="mergedReceiptSelection()" class="search-action fa-file-invoice-dollar"
			   *ngIf="this.excSecurity.isFeatured('RECEIPTCREATE') && selectKey === 'vorgID'"
			   flow="left"
			   [class.fa-duotone]="selectedDocsCount > 0"
			   [class.fa-regular]="selectedDocsCount === 0"
			   [class.disabled]="selectedDocsCount === 0"
			   [tooltip]="getRessource('tooltip.mergeToReceipt')">
			</i>
			<i (click)="mergedReceiptSelection(true)" class="search-action fa-file-lines"
			   *ngIf="this.excSecurity.isFeatured('STATEMENTCREATE') && selectKey === 'vorgID'"
			   flow="left"
			   [class.fa-duotone]="selectedDocsCount > 0"
			   [class.fa-regular]="selectedDocsCount === 0"
			   [class.disabled]="selectedDocsCount === 0"
			   [tooltip]="getRessource('tooltip.mergeToStatement')">
			</i>
			<i (click)="deleteSelection()" class="search-action fa-trash-can-list"
			   flow="left"
			   [class.fa-duotone]="selectedDocsCount > 0"
			   [class.fa-regular]="selectedDocsCount === 0"
			   [class.disabled]="selectedDocsCount === 0"
			   [tooltip]="getRessource('tooltip.DeleteSection')"></i>
			<i (click)="selectedSummary?.LoadSummary();"
			   flow="left"
			   [tooltip]="getRessource('tooltip.Sync')"
         class="search-action fa-duotone fa-sync"></i>
		</ng-template>
	</exg-search-bar>
	<div class="content">
		<ng-container *ngIf="!selectedSummary?.attachmentJagTable?.isLoading && !init">
			<ng-container *ngFor="let folder of selectedSummary?.attachmentJagTable?.jagdata">
				<div class="grid-1-auto app-space_075">
					<div *ngIf="folder.source === 'document'">
						{{enmSrv.getEnumerationText('DokTyp', folder.dok_enmIdent_DokTyp)}}
					</div>
					<div *ngIf="folder.source === 'report'">
						{{getRessource('reportFolder')}}
					</div>
					<div *ngIf="folder.source === 'Fragebogen'">
						{{getRessource('questFolder')}}
					</div>
					<div>({{folder.dokFolderCount}})</div>
				</div>
				<div class="flex-container app-space_025">
					<div class="flex-row">
						<ng-container *ngFor="let docElement of folder.documents">
							<div class="grid-auto-1">
								<div class="app-checkbox-multiSelection"
								     [ngStyle]="{'padding-left': folder.dok_enmIdent_DokTyp === -1 ? '2.75em' : '0'}">
									<exg-checkbox *ngIf="folder.dok_enmIdent_DokTyp !== -1"
																[id]="docElement.dokID + 'selection'"
																[ngModel]="selectedDocs[docElement.dokID]"
																(ngModelChange)="selection(docElement.dokID, $event)">
									</exg-checkbox>
								</div>
								<div class="md3-card-on-surface app-space width-400"
								     style="padding: 4px 8px; margin: 4px 4px;">
									<div class="grid-auto-1">
										<ng-container *ngIf="docElement.dokMode !== 'Bericht' && docElement.dokMode !== 'Fragebogen'">
											<div style="cursor: pointer" class="list-avatar-placeholder">
												<span style="font-size: medium"
												      [tooltip]="getRessource('tooltip.edit')" flow="right">
													<img src="{{excRest.computeUrl('ImageThumbnail',{dokID: docElement.dokID})}}"
													     (click)="localConfig.showAttachmentPreview(docElement.dokID)" alt=""
													     class="list-avatar-placeholder"/>
												</span>
											</div>
										</ng-container>
										<ng-container *ngIf="docElement.dokMode === 'Bericht'">
											<div class="typo-center app-space-right_075 app-cursor-pointer"
											     (click)="localConfig.openReport(docElement.dokID)"
											     style="height: available">
												<span flow="right" style="font-size: medium"
												      [tooltip]="getRessource('tooltip.openReport')">
													<i class="fa-2xl fa-duotone fa-file-check "></i>
												</span>
											</div>
										</ng-container>
										<ng-container *ngIf="docElement.dokMode === 'Fragebogen'">
											<div class="typo-center app-space-right_075">
												<span style="font-size: medium"
												      [tooltip]="getRessource('tooltip.openQuestionnaire')" flow="right">
													<i class="fa-2xl fa-duotone fa-clipboard-list"></i>
												</span>
											</div>
										</ng-container>
										<div class="layout-auto-1-auto-grid-1-auto grid typo-small">
											<div class="list-metadata" style="margin-left:0">
												<div>
													<ng-container *ngIf="docElement.linked">
														<span flow="left" style="font-size: medium"
														      [tooltip]="getRessource('tooltip.linked')">
															<i class="fal fa-link"></i>
															<ng-container *ngIf="!docElement.dokTrackingPortalShare">
																&nbsp;-&nbsp;
															</ng-container>
														</span>
													</ng-container>
													<ng-container *ngIf="docElement.dokTrackingPortalShare">
														<span flow="left" style="font-size: medium"
														      [tooltip]="getRessource('tooltip.trackingPortal')">
															<i class="fal fa-cloud"></i> -
														</span>
													</ng-container>
													{{docElement.dok_enmIdent_DokTyp >= 0 && docElement.dokGroesse > 0 ? appSvc.file.calcFileSize(docElement.dokGroesse, false) + ' - ' : ''}}
													{{docElement.dokMode}}
												</div>
											</div>
											<div class="grid-1-auto">
												<div class="list-metadata ">
													<div class="typo-right">
														{{docElement.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
													<div class="typo-right">{{docElement.dokCRU}}</div>
												</div>
											</div>
											<div class="span-2">
												<div class="grid-1-auto">
													<div style="overflow: hidden">
														<strong>{{docElement.dokName}}{{docElement.dokErw}}</strong>
													</div>
													<div class="typo-right app-space-top_1">
														<ng-container *ngIf="docElement.dokMode !== 'Bericht' && docElement.dokMode !== 'Fragebogen'">
									            <span flow="left" style="font-size: medium"
									                  [tooltip]="getRessource('tooltip.download')">
																<i class="search-action fa-duotone fa-download"
																   (click)="appSvc.file.dokument.download(docElement.dokID)">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.PDFSplitting')">
																<i class="search-action fa-file-pdf"
																   [class.fa-duotone]="docElement.dokName.toUpperCase().endsWith('.PDF')"
																   [class.fa-regular]="!docElement.dokName.toUpperCase().endsWith('.PDF')"
																   [class.disabled]="!docElement.dokName.toUpperCase().endsWith('.PDF')"
																   (click)="localConfig.showPDFEditorOverlay(docElement.dokID, !docElement.dokName.toUpperCase().endsWith('.PDF'))">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.edit')">
																<i class="search-action fa-duotone fa-pencil-alt"
																   *ngIf="excSecurity.isFeatured('DOCUMENTEDIT')"
																   [class.fa-duotone]="(docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1"
																   [class.fa-regular]="!((docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1)"
																   [class.disabled]="!((docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1)"
																   (click)="localConfig.showAttachmentUpdateModal(docElement)">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.toReceipt')">
																<i class="search-action fa-file-invoice-dollar" style="margin-bottom: .5rem"
																   *ngIf="selectKey === 'vorgID'"
																   [class.fa-duotone]="excSecurity.isFeatured('RECEIPTCREATE') && isValidReceipt(docElement.dokName)"
																   [class.fa-regular]="!(excSecurity.isFeatured('RECEIPTCREATE') && isValidReceipt(docElement.dokName))"
																   [class.disabled]="!(excSecurity.isFeatured('RECEIPTCREATE') && isValidReceipt(docElement.dokName))"
																   (click)="localConfig.addAttachmentToReceipts(docElement)">
																</i>
						                  </span>
                              <span flow="left" style="font-size: medium"
                                    [tooltip]="getRessource('tooltip.toStatement')">
                                <i class="search-action fa-file-lines" style="margin-bottom: .5rem"
                                   *ngIf="selectKey === 'vorgID'"
                                   [class.fa-duotone]="excSecurity.isFeatured('STATEMENTCREATE') && isValidReceipt(docElement.dokName)"
                                   [class.fa-regular]="!(excSecurity.isFeatured('STATEMENTCREATE') && isValidReceipt(docElement.dokName))"
                                   [class.disabled]="!(excSecurity.isFeatured('STATEMENTCREATE') && isValidReceipt(docElement.dokName))"
                                   (click)="localConfig.addAttachmentToStatements(docElement)">
                                </i>
                              </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.delete')">
																<i class="search-action fa-trash-alt" style="margin-bottom: .5rem"
																   [class.fa-duotone]="(docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1"
																   [class.fa-regular]="!((docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1)"
																   [class.disabled]="!((docElement.dokCRL === this.excSecurity.UserLogin) || this.userType === 1)"
																   (click)="localConfig.deleteAttachment(docElement)">
																</i>
						                  </span>
														</ng-container>

														<ng-container *ngIf="docElement.dokMode === 'Bericht'">
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.openReport')">
																<i class="search-action fa-duotone fa-pencil-alt"
																   (click)="localConfig.openReport(docElement.dokID)">
																</i>
															</span>
														</ng-container>

														<ng-container *ngIf="docElement.dokMode === 'Fragebogen'">
						                  <span flow="left" style="font-size: medium"
						                        [tooltip]="getRessource('tooltip.exportQuestionnaireExcel')">
																<i class="search-action fa-duotone fa-file-excel"
																   *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
																   (click)="localConfig.exportQuestionnaireReportExcel(docElement)">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.exportQuestionnairePDF')">
																<i class="search-action fa-duotone fa-file-pdf"
																   *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
																   (click)="localConfig.exportQuestionnaireReportPDF(docElement)">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.editQuestionnaire')">
																<i class="search-action fa-duotone fa-pencil-alt"
																   *ngIf="excSecurity.isFeatured('RQUESTVEDIT')"
																   (click)="localConfig.editQuestionnaireVersion(docElement)">
																</i>
						                  </span>
															<span flow="left" style="font-size: medium"
															      [tooltip]="getRessource('tooltip.openQuestionnaire')">
																<i class="search-action fa-duotone fa-clipboard-list"
																   *ngIf="excSecurity.isFeatured('RQUESTVEDIT')"
																   (click)="localConfig.openQuestionnaire(docElement)">
																</i>
						                  </span>
														</ng-container>
													</div>
												</div>
											</div>
											<div class="span-2 list-secondary-text">{{docElement.dokBeschreibung}}</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</ng-container>
		<div class="splash loading" *ngIf="selectedSummary?.attachmentJagTable?.isLoading">
			<div class="spinner">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
		<div class="splash empty" *ngIf="selectedSummary?.attachmentJagTable?.isEmpty && !selectedSummary?.attachmentJagTable?.isLoading">
			<p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
		</div>
	</div>
</div>
